export enum ValidationType {
  None =            -1,
  Numeric =         1,
  Alphanumeric =    2,
  Email =           3,
  Phone =           4,
  Zip =             5,
  Presence =        6,
  Datetime =        7,
  Url =             8,
  Currency =        9,
  Pattern =         10,
  Length =          11,
  SocialSecurity =  12,
  TotalFileSize =   13,
  Verified =        14,
  PanFormat =       15,
  SingleFile =      16,
  Validator =       17,
  FileDropzone =    18,
  Percentage =      19,
}
